import React from "react";

import { ButtonPlans, ContainerModal, FiliaisAddContainer, ProdutoresContainer, ViewToggleRow, DocsCardsGrid, DocCard, DocCardTopRow, DocCardOpenButton } from "./styles";
import SwitchLayout from "../../components/SwitchLayout";
import api from "../../services/api";
import identifyErrorMenssage from "../../services/identifyErrorMenssage";
import estados from '../../services/estados';
import buscaCep from '../../services/buscaCep';
import { Container } from "react-grid-system";
import GenericUpper from "../../components/generic-upper";
import Button from "../../components/button";
import TableWithLabelBlackV2 from "../../components/TableWithLabelBlack/indexV2";
import ButtonV2 from "../../components/button/button_v2";
import { Loading } from "../../components/loading";
import NotFound from "../../components/NotFound";
import Input from '../../components/input/input_v2';
import Select from '../../components/select/select_v2';
import ModalGeneric from '../../components/modal/modalGeneric';
import InputSearch from "../../components/input-search-documentos";
import ModalDocumentos from "../../components/modal/modalDocumento";
import ModalFuncaoBloqueada from '../../components/modal/modalFuncaoBloqueada';
import ModalTelefone from '../../components/modal/modalCadTelefoneEmergencia';
import ModalLimiteImpressao from '../../components/modal/modalFuncaoBloqueadaImpressaoFe';

import { store } from "react-notifications-component";

import { theme } from "../../styles/theme";
import { BodyM, H5, TaglineP } from "../../styles/stylesTypography";

export const USER = "@userinfo";

class DocSeguranca extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            documentos: [],
            textfile: [],
            limit: 5,
            loading: false,
            hideButton: false,
            offset: 0,
            showmodal: false,
            modalClose: false,
            result: '',
            newfichas: [],
            fichas: [],
            fichasToFind: [],
            fichasTotais: [],
            iframe: "",
            campo_busca: "",
            value_select: "*",
            tempoPesquisa: true,
            modalTesteGratis: false,
            modalTelefone: false,
            modalLimiteImpressao: false,
            modalText: "",
            user: [],
            loaded: true,
            tipoLoja: '',
            loadingFE: false,
            loadingPDF: false,
            submitAttempted: false,
            lastFichaIdErroFE: null,
            // Campos do formulário do modal de telefone/emergência
            nome_fantasia: "",
            razao_social: "",
            cnpj: "",
            telefone: "",
            telefone_emergencia: "",
            cep: "",
            endereco: "",
            numero: "",
            bairro: "",
            cidade: "",
            estado: "",
            inscricao_estadual: "",
            // Upload de logomarca
            file: [],
            namesfiles: [],
            imageEmpresa: null,
            previewImage: null,
            layoutView: window.innerWidth <= 768 ? 'cards' : 'table',
        };
    }

    changeLayoutView = (next) => {
        if (next === this.state.layoutView) return;
        this.setState({ layoutView: next });
    }

    handleOpenDocumento = (ficha) => {
        if (ficha.tipo === 'FQ') {
            this.redicttoPDF(ficha.id);
        } else {
            this.downloadFE(ficha.id);
        }
    }

    async componentDidMount() {
        this.setState({ loading: true })
        const user = JSON.parse(localStorage.getItem("@userinfo"));
        this.setState({ user });
        // Precisa esperar o fetch de verdade antes de tirar o loading - senão
        // "loading" já virava false antes da resposta chegar, e a tela
        // mostrava "Nenhum resultado encontrado" por um instante (fichas
        // ainda vazio) até os dados aparecerem.
        await this.voltaNormal();
        this.setState({ loading: false })
    };


    //---------------------------->
    // Função auxiliar para ordenar por data de atualização (mais recente primeiro)
    sortByDateDesc = (data) => {
        return data.sort((a, b) => {
            const dateA = new Date(a.data_atualizacao);
            const dateB = new Date(b.data_atualizacao);
            return dateB - dateA; // Ordem decrescente (mais recente primeiro)
        });
    };

    formatFichasEmergencia = fe => {
        if (fe !== undefined) {
            fe = fe.map(fe => {
                const format = {
                    id: fe.id,
                    nome_produto: fe.nome_comercial ? fe.nome_comercial : fe.nome_produto,
                    manufacturer: { nome: fe.fabricante },
                    data_atualizacao: fe.data_atualizacao,
                    tipo: fe.tipo
                };

                return format;
            });
            // Ordenar por data de atualização (mais recente primeiro)
            return this.sortByDateDesc(fe);
        }
    };

    formatFichas = fe => {
        fe = fe.map(fe => {
            const format = {
                id: fe.id,
                nome_produto: fe.nome_comercial ? fe.nome_comercial : fe.nome_produto,
                manufacturer: { nome: fe.manufacturer.nome },
                data_atualizacao: fe.data_atualizacao_fabricante ? fe.data_atualizacao_fabricante.substr(0, 10) : null,
                tipo: fe.tipo
            };

            return format;
        });
        // Ordenar por data de atualização (mais recente primeiro)
        return this.sortByDateDesc(fe);
    };

    formatAllDocumentsForFISPQ = fe => {

        let newFE = []
        fe.map(fe => {
            if (fe.tipo === 'FQ') {
                const format = {
                    id: fe.id,
                    nome_produto: fe.nome_produto,
                    manufacturer: {
                        nome: fe.fabricante
                    },
                    data_atualizacao: fe.data_atualizacao,
                    tipo: fe.tipo
                };

                newFE = [...newFE, format];
            }
        });

        // Ordenar por data de atualização (mais recente primeiro)
        return this.sortByDateDesc(newFE);
    };

    formatAllDocumentsForFE = fe => {

        let newFE = []
        fe.map(fe => {
            if (fe.tipo === 'FE') {
                const format = {
                    id: fe.id,
                    nome_produto: fe.nome_produto,
                    manufacturer: {
                        nome: fe.fabricante
                    },
                    data_atualizacao: fe.data_atualizacao,
                    tipo: fe.tipo
                };

                newFE = [...newFE, format];
            }
        });

        // Ordenar por data de atualização (mais recente primeiro)
        return this.sortByDateDesc(newFE);
    };

    formatAllDocuments = fe => {
        fe = fe.map(fe => {
            const format = {
                id: fe.id,
                nome_produto: fe.nome_produto,
                manufacturer: {
                    nome: fe.fabricante
                },
                data_atualizacao: fe.data_atualizacao,
                tipo: fe.tipo
            };

            return format;
        });
        // Ordenar por data de atualização (mais recente primeiro)
        return this.sortByDateDesc(fe);
    };

    formatFISPQS = fq => {

        let format = [];

        fq.map(f => {
            if (f.nome_comercial != "" && f.manufacturer && f.data_atualizacao_fabricante && f.tipo) {
                let i = {
                    id: f.id,
                    nome_produto: f.nome_comercial,
                    manufacturer: f.manufacturer,
                    data_atualizacao: f.data_atualizacao_fabricante.substr(0, 10),
                    tipo: f.tipo
                }
                format = [...format, i];
            } else {
            }
            // return format;
        });

        // Ordenar por data de atualização (mais recente primeiro)
        return this.sortByDateDesc(format);
    };

    handleClickStart = e => {
        e.preventDefault();
        this.setState({
            run: true
        });

    };

    loadMore = async () => {

        if (this.state.value_select == "*") {
            this.setState({ loading: true, hideButton: true });
            const { limit, offset, fichas } = this.state;
            const newOffset = limit + offset;
            try {
                const response = await api.get(
                    "/documentos/seguranca?limit=" + limit + "&offset=" + newOffset
                );
                let documentos = response.data.data;
                let FichasConCat = this.formatFichasEmergencia(documentos);
                FichasConCat = fichas.concat(FichasConCat);
                this.setState({
                    fichas: FichasConCat,
                    offset: newOffset,
                    hideButton: false
                });
            } catch (erro) {
                this.setState({ hideButton: true });

            }
        } else if (this.state.value_select == "FE") {
            try {
                this.setState({ loading: true, hideButton: true });
                const { limit, offset, fichas } = this.state;
                const newOffset = limit + offset;
                const feFind = await api.get(`/fichas?limit=${limit}&offset=${newOffset}`);
                let fe = feFind.data.data;
                let fichasConCat = this.formatFichas(fe);
                fichasConCat = fichas.concat(fichasConCat);
                this.setState({ hideButton: false, fichas: fichasConCat, offset: newOffset })

            } catch (error) {

            }
        } else if (this.state.value_select == "FQ") {
            try {
                this.setState({ loading: true, hideButton: true });
                const { limit, offset, fichas } = this.state;
                const newOffset = limit + offset;
                const fichasfind = await api.get(`/fispq?limit=${limit}&offset=${newOffset}`);
                let fichasFinded = fichasfind.data.data;
                let fichasConCat = this.formatFISPQS(fichasFinded);
                fichasConCat = fichas.concat(fichasConCat);

                this.setState({ hideButton: false, fichas: fichasConCat, offset: newOffset });

            } catch (error) {

            }

        }
        this.setState({ loading: false });
    };

    searchFild = (value) => {

    };

    openModal = e => {
        this.setState({ showmodal: true });
    };

    modalClose = e => {
        if (this.state.showmodal == true) {
            this.setState({ showmodal: false });
        }

        if (this.state.modalTelefone == true) {
            // this.setState({ modalTelefone: false });
            window.location = '/documentos_seguranca';
        }

        if (this.state.modalLimiteImpressao == true) {
            // this.setState({ modalLimiteImpressao: false });
            window.location = '/documentos_seguranca';

        }
    };

    redicttoPDF = async (id) => {
        try {
            if (this.state.loadingPDF === false) {

                this.setState({ loadingPDF: true });

                const response = await api.get(`/documentos/fds/${id}`);
                let pdf = response.data.link;
                window.open(pdf)

                this.setState({ loadingPDF: false });

            }
        } catch (error) {

            if (error.response.data.errors === "Você atingiu o limite de impressões gratuitas!") {
                this.setState({ modalLimiteImpressao: true });

            } else {
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(error, "ERRO-654 Tente novamente mais tarde - Tente novamente, se o erro persistir acione o suporte."),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
            }
        }

    };

    voltaNormal = async () => {
        this.setState({ value_select: "*" });
        const response = await api.get(`/documentos/seguranca?limit=5&offset=0`);
        let documentos = response.data.data;
        documentos = this.formatFichasEmergencia(documentos);
        this.setState({ fichas: documentos })
    };

    update_select = async (value) => {
    };

    updateValues = async (text, isSearch, select) => {
        const { limit, offset } = this.state;
        this.setState({ loading: true });

        if (text.length > 2) {
            if (isSearch === 1) {
                if (select === 'FQ') {
                    if (text === '') {
                        try {
                            const fichasfind = await api.get(`/fispq?limit=${limit}&offset=${offset}`);
                            let fichasFinded = fichasfind.data.data;
                            fichasFinded = this.formatFISPQS(fichasFinded)
                            this.setState({ hideButton: false, fichas: fichasFinded })
                        } catch (error) {

                        }
                    } else if (text !== '') {
                        try {
                            await api.get(`/documentos/seguranca?value=${text}`).then(response => {
                                let todosDocumentos = response.data.data;
                                todosDocumentos = this.formatAllDocumentsForFISPQ(todosDocumentos);
                                this.setState({ fichas: todosDocumentos });
                            })
                        } catch (error) {

                        }
                    }
                } else if (select === 'FE') {
                    if (text === '') {
                        try {
                            const feFind = await api.get(`/fichas?limit=${limit}&offset=${offset}`);
                            let fe = feFind.data.data;
                            fe = this.formatFichas(fe);
                            this.setState({ hideButton: false, fichas: fe })
                        } catch (error) {

                        }
                    } else if (text !== '') {
                        try {
                            await api.get(`/documentos/seguranca?value=${text}`).then(response => {
                                let todosDocumentos = response.data.data;
                                todosDocumentos = this.formatAllDocumentsForFE(todosDocumentos);
                                this.setState({ fichas: todosDocumentos });
                            })
                        } catch (error) {

                        }
                    }
                } else if (select === '' || select === '*') {

                    if (text === '') {
                        await api.get(`/documentos/seguranca?limit=${limit}&offset=${offset}`).then(response => {
                            let todosDocumentos = response.data.data;
                            todosDocumentos = this.formatAllDocuments(todosDocumentos);
                            this.setState({ fichas: todosDocumentos });
                        })
                    } else {
                        await api.get(`/documentos/seguranca?value=${text}`).then(response => {
                            let todosDocumentos = response.data.data;
                            todosDocumentos = this.formatAllDocuments(todosDocumentos);
                            this.setState({ fichas: todosDocumentos });
                        })
                    }
                }
            }

        } else if (text.length === 0) {
            await this.voltaNormal()
        }


        this.setState({ loaded: false });
        this.setState({ limit: 5 });
        this.setState({ offset: 0 });

        const valor = text;
        const tipo = select;

        this.setState({ value_select: tipo })

        this.setState({ loaded: true });
        this.setState({ loading: false });
    };

    updateResposta = async (resposta) => {
        if (resposta == 0) {
            this.setState({ showmodal: false })
        }
    };



    downloadFE = async (id) => {
        try {
            if (this.state.loadingFE === false) {

                this.setState({ loadingFE: true });

                let expedidor = await api.get(`/expedidor`);
                expedidor = expedidor.data.data.id;
                const response = await api.post(`/ficha/${expedidor}/${id}`);
                const link = response?.data?.data?.link;
                window.open(`${link}`);

                this.setState({ loadingFE: false });
            }

        } catch (err) {
            

            if (err.response.data.errors) {
                if (err.response.data.errors != "Você atingiu o limite de impressões gratuitas.") {
                    const responseGetFiliais = await api.get(`/filiais`);
                    const dataGetFiliais = responseGetFiliais.data.data[0].id;

                    const responsegetFiliaisId = await api.get(`/filiais/${dataGetFiliais}`);
                    const filiais = responsegetFiliaisId.data.data;

                    this.setState({ modalTelefone: true, lastFichaIdErroFE: id });

                    const {
                        nome_fantasia,
                        razao_social,
                        cnpj,
                        telefone,
                        cep,
                        endereco,
                        numero,
                        bairro,
                        cidade,
                        estado,
                        logo,
                        is_matriz,
                        imageEmpresa = filiais.logo,
                        telefone_emergencia,
                        inscricao_estadual
                    } = filiais;
            
                    this.setState({
                        filialId: dataGetFiliais,
                        nome_fantasia,
                        razao_social,
                        cnpj,
                        telefone,
                        cep,
                        endereco,
                        numero,
                        bairro,
                        cidade,
                        estado,
                        imageEmpresa,
                        is_matriz,
                        logo,
                        inscricao_estadual,
                        telefone_emergencia
                    });

                    if (err.response?.data?.data?.is_matriz) {
                        this.setState({ tipoLoja: err.response.data.is_matriz });
                    }
                } else {

                    if (err.response.data.errors === "Você atingiu o limite de impressões gratuitas.") {

                        this.setState({ modalLimiteImpressao: true });

                    } else {
                        store.addNotification({
                            title: "Erro!",
                            message: identifyErrorMenssage(err, "ERRO-655 Tente novamente mais tarde - Tente novamente, se o erro persistir acione o suporte."),
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 5000,
                                onScreen: true
                            }
                        });
                    }
                }
            }
        } finally {
            this.setState({ loadingFE: false });
        }
    };

    onKeyDown = (e) => {
        e.preventDefault();
        const { campo_busca } = this.state;
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            this.searchFild(campo_busca);
        }
    };

    handleSalvarEmpresa = async () => {
        const {
            filialId,
            nome_fantasia,
            razao_social,
            cnpj,
            telefone,
            telefone_emergencia,
            cep,
            endereco,
            bairro,
            numero,
            cidade,
            estado,
            file,
            inscricao_estadual
        } = this.state;

        this.setState({ submitAttempted: true });
        
        const required = {
            nome_fantasia,
            razao_social,
            cnpj,
            telefone,
            telefone_emergencia,
            cep,
            endereco,
            bairro,
            numero,
            cidade,
            estado,
        };
        const empties = Object.entries(required).filter(([_, v]) => !v || (typeof v === 'string' && v.trim() === ''));
        if (empties.length > 0) {
            store.addNotification({
                title: "Erro!",
                message: "Preencha todos os campos obrigatórios",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
            return;
        }

        let id = filialId;
        try {
            if (!id) {
                const responseGetFiliais = await api.get(`/filiais`);
                id = responseGetFiliais.data?.data?.[0]?.id;
                this.setState({ filialId: id });
            }

            const payload = {
                is_matriz: 1,
                nome_fantasia,
                razao_social,
                cnpj,
                telefone,
                telefone_emergencia,
                logo: Array.isArray(file) && file.length > 0 ? file : "",
                cep,
                endereco,
                bairro,
                numero,
                cidade,
                estado,
                inscricao_estadual
            };

            this.setState({ loadingSalvar: true });
            const response = await api.put(`/filiais/${id}`, payload);

            if (response.status === 200) {
                store.addNotification({
                    title: "Sucesso!",
                    message: "Dados da empresa salvos corretamente.",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });

                this.setState({ modalTelefone: false });

                const { lastFichaIdErroFE } = this.state;
                if (lastFichaIdErroFE) {
                    try {
                        await this.downloadFE(lastFichaIdErroFE);
                    } finally {
                        this.setState({ lastFichaIdErroFE: null });
                    }
                }
            }
        } catch (err) {
            if ((err.response && err.response.status === 413) || (err.message === "Network Error")) {
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(err, "ERRO-656 Houve um problema para salvar a imagem. Tente enviá-la em uma dimensão menor - Tente novamente, se o erro persistir acione o suporte."),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            } else {
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(err, "ERRO-657 Verifique os campos vazios - Tente novamente, se o erro persistir acione o suporte."),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }
        } finally {
            this.setState({ loadingSalvar: false });
        }
    };

    fetchCep = async () => {
        const { cep } = this.state;

        try {
            if (!cep) return;
            const responseCep = await buscaCep(cep.replace('.', ''));
            const { logradouro, localidade, bairro, uf } = responseCep;

            this.setState({
                endereco: logradouro,
                cidade: localidade,
                bairro: bairro,
                estado: uf
            });
        } catch (err) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(err),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    };

    onChange = async (e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];

            if (file.type !== "image/png" && file.type !== "image/jpeg") {
                store.addNotification({
                    title: "Erro!",
                    message: "O arquivo selecionado não possui a extensão correta. Selecione uma imagem PNG/JPEG e tente novamente.",
                    type: "warning",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
                e.target.value = '';
                return;
            }

            if (file.size > 3 * 1024 * 1024) {
                store.addNotification({
                    title: "Erro!",
                    message: "O arquivo deve ter no máximo 3MB - Selecione uma imagem menor e tente novamente.",
                    type: "warning",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
                e.target.value = '';
                return;
            }

            const img = new Image();
            const reader = new FileReader();

            reader.onload = (event) => {
                img.src = event.target.result;
                img.onload = () => {
                    this.setState({
                        file: event.target.result,
                        imageEmpresa: null,
                        previewImage: event.target.result,
                        textfile: "Imagem selecionada com sucesso!"
                    });

                    if (!this.state.namesfiles.includes(file.name)) {
                        this.state.namesfiles.push(file.name);
                    }
                };
            };

            reader.readAsDataURL(file);
        }
    };

    formatarData = (dataISO) => {
        if (!dataISO) return 'N/D';
        const data = new Date(dataISO);
        if (isNaN(data.getTime())) return 'N/D';
        const meses = ['JAN','FEV','MAR','ABR','MAI','JUN','JUL','AGO','SET','OUT','NOV','DEZ'];
        const dia = String(data.getUTCDate()).padStart(2, '0');
        const mes = meses[data.getUTCMonth()];
        const ano = data.getUTCFullYear();
        return `${dia}/${mes}/${ano}`;
    }

    render() {
        const {
            showmodal,
            fichas,
            hideButton,
            loading,
            value_select,
            modalTesteGratis,
            nome_fantasia,
            razao_social,
            cnpj,
            telefone,
            telefone_emergencia,
            cep,
            inscricao_estadual,
            endereco,
            numero,
            bairro,
            cidade,
            estado,
            submitAttempted,
            layoutView
        } = this.state;
        return (
            <>
                <GenericUpper
                    title="Documentos de Segurança"
                    search={true}
                    searchFunction={(text, isSearch, select) => { this.updateValues(text, 1, select)}}
                    placeholder="Produto, Fabricante"
                    tooltip={"Solicitar"}
                    docSeguranca={true}
                    valueSelect={value_select}
                    estados={true}
                    addLinkModal={() =>
                        this.state.user.contract_software_id == 6 ?
                            this.setState({ modalTesteGratis: true }) : this.setState({ showmodal: true })
                    }
                ></GenericUpper>

                <ProdutoresContainer style={{ padding: '24px 0'}}>
                    <Container>
                        <>
                            <ViewToggleRow>
                                <SwitchLayout
                                    isTableView={layoutView === 'table'}
                                    onClick={() => this.changeLayoutView(layoutView === 'table' ? 'cards' : 'table')}
                                />
                            </ViewToggleRow>

                            {layoutView === 'table' ? (
                                <TableWithLabelBlackV2
                                    columns={[
                                        {
                                            key: 'nome_produto',
                                            label: 'Nome do Produto',
                                            width: '100%',
                                            minWidth: '200px',
                                            maxWidth: '400px',
                                            maxWidthContent: '400px',
                                            enableHorizontalScroll: true,
                                            render: (d) => (
                                                <BodyM color={theme.colors.gray.Cinza_2} fontWeight={800}>{d.nome_produto}</BodyM>
                                            )
                                        },
                                        {
                                            key: 'fabricante',
                                            label: 'Fabricante',
                                            width: '100%',
                                            minWidth: '140px',
                                            maxWidth: '220px',
                                            maxWidthContent: '220px',
                                            enableHorizontalScroll: true,
                                            render: (d) => (
                                                <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={600}>{d.manufacturer ? d.manufacturer.nome : ''}</TaglineP>
                                            )
                                        },
                                        {
                                            key: 'data_atualizacao',
                                            label: 'Data de Atualização',
                                            width: '100%',
                                            minWidth: '140px',
                                            maxWidth: '250px',
                                            maxWidthContent: '250px',
                                            render: (d) => (
                                                <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={600}>
                                                   {`Atualizado ${this.formatarData(d.data_atualizacao)}`}
                                                </TaglineP>
                                            )
                                        },
                                        {
                                            key: 'tipo',
                                            label: 'Tipo',
                                            width: '100%',
                                            minWidth: '150px',
                                            maxWidth: '240px',
                                            render: (d) => (
                                                <div style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '4px 12px',
                                                    borderRadius: '10rem',
                                                    backgroundColor: theme.colors.gray.Cinza_2,
                                                    color: '#fff',
                                                    fontSize: '11px',
                                                    fontWeight: '700',
                                                    letterSpacing: '0.5px',
                                                    whiteSpace: 'nowrap'
                                                }}>
                                                    {d.tipo === 'FQ' ? 'FDS(FISPQ)' : 'Ficha de Emergência'}
                                                </div>
                                            )
                                        }
                                    ]}
                                    data={fichas}
                                    showAll={true}
                                    serverSide={true}
                                    itemsPerPage={fichas.length || 5}
                                    enableDefaultRowNavigation={false}
                                    isLoading={loading}
                                    emptyMessage={<NotFound message="Nenhum resultado encontrado." />}
                                    onRowClick={(ficha) => this.handleOpenDocumento(ficha)}
                                />
                            ) : (
                                <DocsCardsGrid>
                                    {fichas.map((ficha, idx) => (
                                        <DocCard
                                            key={ficha.id ?? idx}
                                            onClick={() => this.handleOpenDocumento(ficha)}
                                        >
                                            <DocCardTopRow>
                                                <div style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '4px 12px',
                                                    borderRadius: '10rem',
                                                    backgroundColor: theme.colors.gray.Cinza_2,
                                                    color: '#fff',
                                                    fontSize: '11px',
                                                    fontWeight: '700',
                                                    letterSpacing: '0.5px',
                                                    whiteSpace: 'nowrap'
                                                }}>
                                                    {ficha.tipo === 'FQ' ? 'FDS(FISPQ)' : 'Ficha de Emergência'}
                                                </div>

                                                <DocCardOpenButton
                                                    aria-label="Abrir em uma nova aba"
                                                    title="Abrir em uma nova aba"
                                                    onClick={(e) => { e.stopPropagation(); this.handleOpenDocumento(ficha); }}
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                                        <path d="M18 13v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M15 3h6v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M10 14 21 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </DocCardOpenButton>
                                            </DocCardTopRow>

                                            <BodyM color={theme.colors.gray.Cinza_2} fontWeight={800}>
                                                {ficha.nome_produto}
                                            </BodyM>

                                            <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={600}>
                                                {ficha.manufacturer ? ficha.manufacturer.nome : ''}
                                            </TaglineP>

                                            <TaglineP color={theme.colors.gray.Cinza_5} fontWeight={600}>
                                                {`Atualizado ${this.formatarData(ficha.data_atualizacao)}`}
                                            </TaglineP>
                                        </DocCard>
                                    ))}

                                    {loading && (
                                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '40px 0' }}>
                                            <Loading size="48px" color={theme.colors.green.Verde_AgroReceita} />
                                        </div>
                                    )}

                                    {!loading && fichas.length === 0 && (
                                        <NotFound message="Nenhum resultado encontrado." />
                                    )}
                                </DocsCardsGrid>
                            )}

                            <Button
                                style={{ outline: 0 }}
                                className="loadmore"
                                hide={hideButton}
                                outline
                                onClick={this.loadMore}
                                color="#00b43f"
                            >
                                Ver mais
                            </Button>

                            <ModalDocumentos
                                // style={{ display: "flex", justifyContent: "center" }}
                                show={showmodal}
                                onHide={this.modalClose}
                                resposta=''
                                update={this.updateResposta}
                                title='Solicitar um Documento'
                            ></ModalDocumentos>

                            <ModalFuncaoBloqueada
                                show={modalTesteGratis}
                                onHide={() => {
                                    this.modalClose();
                                    this.setState({ modalTesteGratis: false })
                                }}
                            ></ModalFuncaoBloqueada>

                            {/* <ModalTelefone
                                title="Aviso!"
                                text="Para emitir Fichas de Emergência, é necessário cadastrar seu Telefone para Emergência:"
                                show={this.state.modalTelefone}
                                tipoLoja={this.state.tipoLoja}
                                onHide={this.modalClose}
                            >
                            </ModalTelefone> */}

                            <ModalGeneric
                                show={this.state.modalTelefone}
                                onHide={this.modalClose}
                                size='md'
                                marginBottom="0px"
                            >
                                <ContainerModal marginTop="0px">
                                    <H5 color={theme.colors.gray.Cinza_5}>Aviso!</H5>

                                    <BodyM color={theme.colors.gray.Cinza_5}>
                                        Para emitir Fichas de Emergência, é necessário cadastrar seu Telefone para Emergência:
                                    </BodyM>
                                    
                                    <FiliaisAddContainer>
                                        <form>
                                            <Input
                                                name="nome_fantasia"
                                                type="text"
                                                label="Nome Fantasia"
                                                id="id_nome_fantasia"
                                                rows="1"
                                                cols="22"
                                                value={nome_fantasia}
                                                onChange={e => this.setState({ nome_fantasia: e})}
                                                marginBottom="0px"
                                                erro={submitAttempted && !nome_fantasia}
                                            />

                                            <Input
                                                name="razao_social"
                                                type="text"
                                                label="Razão Social"
                                                id="id_razao_social"
                                                rows="1"
                                                cols="22"
                                                value={razao_social}
                                                onChange={e => this.setState({ razao_social: e })}
                                                marginBottom="0px"
                                                erro={submitAttempted && !razao_social}
                                            />

                                            <Input
                                                name="cnpj"
                                                type="text"
                                                label="CNPJ"
                                                id="id_cnpj"
                                                value={cnpj}
                                                onChange={e => this.setState({ cnpj: e })}
                                                marginBottom="0px"
                                                erro={submitAttempted && !cnpj}
                                            />

                                            <Input
                                                name="telefone"
                                                type="text"
                                                label="Telefone"
                                                id="id_telefone"
                                                value={telefone}
                                                onChange={e => this.setState({ telefone: e })}
                                                marginBottom="0px"
                                                erro={submitAttempted && !telefone}
                                            />

                                            <Input
                                                name="telefone_emergencia"
                                                type="text"
                                                label="Telefone de emergência"
                                                id="id_telefone_emergencia"
                                                value={telefone_emergencia}
                                                onChange={e => this.setState({ telefone_emergencia: e })}
                                                marginBottom="0px"
                                                erro={submitAttempted && !telefone_emergencia}
                                            />

                                            <Input
                                                name="cep"
                                                type="text"
                                                label="CEP"
                                                id="id_cep"
                                                value={cep}
                                                onChange={e => this.setState({ cep: e })}
                                                onBlur={this.fetchCep}
                                                marginBottom="0px"
                                                erro={submitAttempted && !cep}
                                            />

                                            {inscricao_estadual !== null && (
                                                    <Input
                                                        name="Inscrição Estadual"
                                                        type="text"
                                                        label="Inscrição Estadual"
                                                        id="inscricao_estadual"
                                                        value={inscricao_estadual}
                                                        onChange={e => this.setState({ inscricao_estadual: e })}
                                                        marginBottom="0px"
                                                        erro={false}
                                                    />
                                                )
                                            }

                                            <Input
                                                name="endereco"
                                                type="text"
                                                label="Endereço"
                                                id="id_endereco"
                                                value={endereco}
                                                onChange={e => this.setState({ endereco: e })}
                                                marginBottom="0px"
                                                erro={submitAttempted && !endereco}
                                            />

                                            <Input
                                                name="numero"
                                                label="Número"
                                                id="id_numero"
                                                value={numero}
                                                onChange={e => this.setState({ numero: e })}
                                                marginBottom="0px"
                                                erro={submitAttempted && !numero}
                                            />

                                            <Input
                                                name="bairro"
                                                type="text"
                                                label="Bairro"
                                                id="id_bairro"
                                                value={bairro}
                                                onChange={e => this.setState({ bairro: e })}
                                                marginBottom="0px"
                                                erro={submitAttempted && !bairro}
                                            />

                                            <Input
                                                name="cidade"
                                                type="text"
                                                label="Cidade"
                                                id="id_cidade"
                                                value={cidade}
                                                onChange={e => this.setState({ cidade: e })}
                                                marginBottom="0px"
                                                erro={submitAttempted && !cidade}
                                            />

                                            <Select
                                                name="estado"
                                                className="select"
                                                label="Estado"
                                                id="id_estado"
                                                value={estado}
                                                onChange={state => this.setState({ estado: state.value })}
                                                options={estados}
                                                estado={true}
                                                marginBottom="0px"
                                                erro={submitAttempted && !estado}
                                            />

                                            <label style={{marginTop: '35px', marginBottom: '2px', marginLeft: '-155px', fontSize: '12px', fontWeight: '700', color: '#8192a2'}}>Adicionar Logomarca</label>
                            
                                            <div 
                                                for='id_input-file' 
                                                onClick={() => document.getElementById('id_input-file').click()}
                                                style={{
                                                    width: '100%',
                                                    height: (this.state.imageEmpresa || this.state.previewImage) ? 'auto' : '108px',
                                                    backgroundColor: `${theme.colors.white.Branco}`,
                                                    borderRadius: '1px',
                                                    border: '1px dashed #8a92a2',
                                                    color: '#8a92a2',
                                                    padding: '12px 20px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                {this.state.imageEmpresa || this.state.previewImage ? (
                                                    <img 
                                                        src={this.state.imageEmpresa || this.state.previewImage} 
                                                        alt="Logo empresa" 
                                                        style={{
                                                            maxWidth: "380px",
                                                            maxHeight: "380px",
                                                            width: 'auto',
                                                            height: 'auto',
                                                            objectFit: 'contain'
                                                        }}
                                                    />
                                                ):(
                                                    <p
                                                    style={{
                                                        width: '100%',
                                                        textAlign: 'center',
                                                        fontSize: '15px',
                                                    }}
                                                >
                                                    {/* {this.state.textfile} */}
                                                    ADICIONAR ANEXOS (JPG ou PNG, MAX 3MB)
                                                </p>
                                                )}
                                            </div>
                                            <input 
                                                style={{marginTop: '20px'}}
                                                type="file"
                                                id="id_input-file"
                                                name="file"
                                                accept="image/png, image/jpeg"
                                                multiple
                                                onChange={(e)=>{
                                                    this.onChange(e)
                                                    
                                                    if (e.target.files.length > 0) {
                                                        this.setState({ imageEmpresa: null })
                                                    }
                                                }}
                                            />

                                            <span id='file-name'></span>
                                        </form>
                                    </FiliaisAddContainer>
                                    
                                        <ButtonPlans>
                                            <ButtonV2
                                                width='100%'
                                                height='60px'
                                                value='Salvar alterações'
                                                outline={false}
                                                disabled={false}
                                                onClick={this.handleSalvarEmpresa}
                                                loading={this.state.loadingSalvar}
                                            />
                                        </ButtonPlans>
                                </ContainerModal>
                            </ModalGeneric>

                            <ModalLimiteImpressao
                                show={this.state.modalLimiteImpressao}
                                onHide={this.modalClose}
                            >

                            </ModalLimiteImpressao>
                        </>
                    </Container>
                </ProdutoresContainer>
            </>
        );
    }
}
export default DocSeguranca;
